<app-ki-button
  funktion="TESTDESIGN"
  [state]="buttonState()"
  [sperrgrund]="sperrgrund()"
  [label]="'ki.anforderungTools.abdeckungPruefen' | translate"
  (ausloesen)="pruefen()"
/>

<app-confirm-dialog
  icon="save"
  confirmColor="primary"
  [visible]="rueckfrageOffen()"
  [title]="'ki.abdeckung.speichernRueckfrage.titel' | translate"
  [message]="'ki.abdeckung.speichernRueckfrage.text' | translate"
  [confirmLabel]="'ki.abdeckung.speichernRueckfrage.bestaetigen' | translate"
  [cancelLabel]="'ki.abdeckung.speichernRueckfrage.abbrechen' | translate"
  [busy]="speichertGerade()"
  (confirmed)="speichernUndPruefen()"
  (cancelled)="rueckfrageAbbrechen()"
/>

@if (run.hinweis(); as verbindung) {
  <app-ki-erste-nutzung
    [verbindung]="verbindung"
    (verstanden)="run.hinweisVerstanden()"
    (abgebrochen)="run.hinweisAbgebrochen()"
  />
}

@if (panelSichtbar()) {
  <app-ki-panel [titel]="'ki.abdeckung.titel' | translate" [kontext]="kontext()" (geschlossen)="panelOffen.set(false)">
    @if (run.zustand().art === 'laeuft') {
      <app-ki-laeuft [aktion]="'ki.abdeckung.laeuft' | translate" />
    }
    @if (fehlerKey(); as textKey) {
      <app-ki-fehler [text]="textKey | translate" (erneut)="run.erneut()" />
    }
    @if (anzeige(); as anfrage) {
      @if (anfrage.ergebnisGeloescht) {
        <app-ki-ergebnis-abgelaufen />
      } @else {
        <div class="ki-abdeckung__kopf">
          <app-ki-badge [label]="'ki.abdeckung.badge' | translate" />
          <span class="ki-abdeckung__zusammenfassung" data-testid="ki-abdeckung-zusammenfassung">
            <strong>{{ 'ki.abdeckung.anzahl' | translate: { offen: offenAnzahl(), gesamt: zeilen().length } }}</strong>
            {{ 'ki.abdeckung.nichtAbgedecktSatz' | translate }}
          </span>
        </div>
        @if (zeilen().length) {
          <ul class="ki-abdeckung__liste">
            @for (zeile of zeilen(); track $index) {
              @let aspekt = zeile.aspekt;
              @let offen = zeile.zustand !== 'ABGEDECKT';
              <li
                class="ki-abdeckung__zeile"
                data-testid="ki-abdeckung-zeile"
                [class.ki-abdeckung__zeile--offen]="offen"
              >
                <div class="ki-abdeckung__haupt">
                  <span class="ki-abdeckung__kreis" [class.ki-abdeckung__kreis--offen]="offen">
                    <mat-icon aria-hidden="true">{{ offen ? 'close' : 'check' }}</mat-icon>
                  </span>
                  <span class="ki-abdeckung__aspekt">{{ aspekt.titel }}</span>
                  <span class="ki-abdeckung__rechts">
                    @if (zeile.zustand === 'NICHT_ABGEDECKT') {
                      <span class="ki-abdeckung__offen-badge">{{ 'ki.abdeckung.nichtAbgedeckt' | translate }}</span>
                    } @else {
                      @if (zeile.zustand === 'NICHT_VERKNUEPFT') {
                        <span class="ki-abdeckung__nicht-verknuepft" data-testid="ki-abdeckung-nicht-verknuepft">
                          {{ 'ki.abdeckung.nichtVerknuepft' | translate }}
                        </span>
                      } @else {
                        {{ 'ki.abdeckung.abgedecktDurch' | translate }}
                      }
                      @if (zeile.testCaseId; as testCaseId) {
                        <button
                          type="button"
                          class="ki-abdeckung__testfall"
                          data-testid="ki-abdeckung-testfall"
                          (click)="testfallOeffnen(testCaseId)"
                        >
                          {{ aspekt.testCaseKey ?? testCaseId }}
                        </button>
                      } @else if (aspekt.testCaseKey) {
                        <code class="ki-abdeckung__testfall">{{ aspekt.testCaseKey }}</code>
                      }
                    }
                  </span>
                </div>
                @if (aspekt.begruendung) {
                  <p class="ki-abdeckung__begruendung">{{ aspekt.begruendung }}</p>
                }
                @if (zeile.zustand === 'NICHT_ABGEDECKT') {
                  <div class="ki-abdeckung__aktion">
                    <button
                      mat-stroked-button
                      type="button"
                      class="ki-abdeckung__entwurf"
                      data-testid="ki-abdeckung-entwurf-erstellen"
                      [disabled]="entwurfGesperrt()"
                      (click)="entwurf(aspekt)"
                    >
                      {{ 'ki.abdeckung.entwurfErstellen' | translate }}
                    </button>
                  </div>
                }
                @if (zeile.zustand === 'NICHT_VERKNUEPFT' && darfVerknuepfen() && zeile.testCaseId; as testCaseId) {
                  <div class="ki-abdeckung__aktion">
                    <button
                      mat-stroked-button
                      type="button"
                      class="ki-abdeckung__entwurf"
                      data-testid="ki-abdeckung-verknuepfen"
                      [disabled]="sendetIds().has(testCaseId)"
                      (click)="verknuepfen(testCaseId)"
                    >
                      {{ 'ki.abdeckung.verknuepfen' | translate }}
                    </button>
                    @if (verknuepfenFehler().get(testCaseId); as fehler) {
                      <app-ki-fehler
                        [text]="fehler.textKey | translate"
                        [erneutAnbieten]="fehler.erneutAnbieten"
                        (erneut)="verknuepfen(testCaseId)"
                      />
                    }
                  </div>
                }
              </li>
            }
          </ul>
        }
        @if (anfrage.gesendet) {
          <app-ki-gesendet [gesendet]="anfrage.gesendet" />
        }
      }
    }
  </app-ki-panel>
}
